<script setup lang="ts">
// A checkbox that supports the indeterminate visual state (not expressible via
// a plain :checked binding). Class and other attrs fall through to the input.
const props = defineProps<{
  checked: boolean
  indeterminate?: boolean
}>()

const el = ref<HTMLInputElement | null>(null)

watchEffect(() => {
  if (el.value) el.value.indeterminate = !!props.indeterminate
})
</script>

<template>
  <input
    ref="el"
    type="checkbox"
    :checked="checked"
    tabindex="-1"
  >
</template>
